// extracted by mini-css-extract-plugin
module.exports = {"header":"_3SmyWN","otherFormats":"_2R2Q18"};